import { render, staticRenderFns } from "./MagnificPopupModal.vue?vue&type=template&id=6536de12&"
import script from "./MagnificPopupModal.vue?vue&type=script&lang=js&"
export * from "./MagnificPopupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports